import { Example } from "../models/ExampleModel";
import { ExplanationModel } from "../models/ExplanationModel";

export const indirectObjectPronounsExplanation: ExplanationModel = {
    title: "📖 What are Pronombres de Objeto Indirecto?",
    description: `
  Indirect object pronouns are used to replace the noun that receives the action indirectly, 
  often answering the question to whom? or for whom? the action is being done. 
    `.trim(),

    bulletPoints: [
        "Indirect object pronouns answer the question to whom? or for whom? the action is done.",
        "The pronoun 'le' (singular) and 'les' (plural) are commonly used for indirect objects.",
        "Examples: Le (to him/her/it), Les (to them).",
    ],
};

export const indirectObjectPronounsExamples: Example[] = [
    {
        sentence: "I give the book to Juan. → Le doy el libro.",
        explanation: "✅ In the sentence 'I give the book to Juan,' the indirect object is 'Juan.' In Spanish, we replace it with 'le': 'Le doy el libro' (I give him the book)."
    },
    {
        sentence: "She buys a gift for her friend. → Le compra un regalo.",
        explanation: "✅ In the sentence 'She buys a gift for her friend,' the indirect object is 'her friend.' In Spanish, we replace it with 'le': 'Le compra un regalo' (She buys him/her a gift)."
    },
    {
        sentence: "We send a letter to our grandparents. → Les enviamos una carta.",
        explanation: "✅ In the sentence 'We send a letter to our grandparents,' the indirect object is 'our grandparents.' In Spanish, we replace it with 'les': 'Les enviamos una carta' (We send them a letter)."
    }
];

export const indirectObjectPronounsExampleExplanation =
    "Here are example usages for different pronouns and conjugation with different tenses.";
